export const READ_ACCOUNTS_LIST = 'READ_ACCOUNTS_LIST';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE';
export const UPDATE_ACCOUNT_FROM_LIST_PAGE = 'CREATE_ACCOUNT';
export const READ_ACCOUNT = 'READ';
export const CHANGE_ACCOUNT_OWNER = 'CHANGE_OWNER';
export const READ_FULL_ACCOUNTS_LIST = 'READ_FULL_ACCOUNTS_LIST';
export const READ_SENSITIVE_ACCOUNT_NAME = 'READ_SENSITIVE_ACCOUNT_NAME';

export const DELIVERY_CONTEXT = 'Delivery';
export const DELIVERY_ACCOUNT_PAUSE_TICKET_RETENTION = 'DELIVERY_ACCOUNT_PAUSE_TICKET_RETENTION';
export const DELIVERY_ACCOUNT_READ_CLIENT_PORTAL_USERS = 'DELIVERY_ACCOUNT_READ_CLIENT_PORTAL_USERS';
export const DELIVERY_ACCOUNT_INVITE_CLIENT_PORTAL_USER = 'DELIVERY_ACCOUNT_INVITE_CLIENT_PORTAL_USER';

const ACCOUNT_TYPES_ALIAS = {
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  OTHER: 'OTHER',
};

export const ACCOUNT_TYPES = {
  [ACCOUNT_TYPES_ALIAS.CUSTOMER]: 'Customer',
  [ACCOUNT_TYPES_ALIAS.PARTNER]: 'Partner',
  [ACCOUNT_TYPES_ALIAS.OTHER]: 'Other',
};
